import React from "react";
import styled from "styled-components";
import { variant } from "styled-system";

import Icon, { IconProps } from "../Icon/Icon";
import { arrowButtonVariants } from "./variants";

const StyledButton = styled.button<{ variant: "dots" | "full-width" }>`
  &.slick-arrow.slick-prev {
    left: 0;
  }
  padding: 0;
  border: none;
  border-radius: 50%;
  top: 50%;
  position: absolute;
  z-index: 3;
  transform: translateY(-50%);
  display: none !important;
  justify-content: center;
  align-items: center;
  ${(props) => {
    const themedVariants = arrowButtonVariants(props.theme);
    return variant({ variants: themedVariants });
  }}
`;

const NavButton: React.FunctionComponent<
  React.HTMLAttributes<HTMLButtonElement> & {
    direction: "left" | "right";
    variant: "full-width" | "dots";
  }
> = ({ direction = "left", variant = "dots", ...props }) => {
  const iconProps: IconProps =
    variant === "full-width"
      ? {
          name: `chevron-${direction}`,
          weight: "regular",
          color: "primary-white",
          width: 20,
          height: 40,
        }
      : {
          name: `chevron-${direction}`,
          weight: "solid",
          color: "grey-blue",
          width: 10,
          height: 20,
        };

  return (
    <StyledButton {...props} aria-label="previous slide" variant={variant}>
      <Icon {...iconProps} />
    </StyledButton>
  );
};

export default NavButton;
